import {FormControl, Grid} from '@mui/material';
import styled from '@emotion/styled';

export const InputFieldGrid = styled(Grid)`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const FormControlDiv = styled(FormControl)`
  width: 100%;
`;

export const ApplicationScreenMainDiv = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  text-align: center;
  flex-direction: column;
  font-size: 24;
  font-weight: 500;
`;
